import type { Location } from 'history'
import { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router'

const useBrowserBackStack = (): Location[] => {
  const history = useHistory()
  const initialLocation = useLocation()
  const [backStack, setBackStack] = useState<Location[]>([initialLocation])
  useEffect(() => {
    history.listen((location, action) => {
      setBackStack(stack => {
        switch (action) {
          case 'POP':
            return stack.slice(0, stack.length - 1)
          case 'PUSH':
            return [...stack, location]
          case 'REPLACE':
            return [...stack.slice(0, stack.length - 1), location]
          default:
            return []
        }
      })
    })
  }, [setBackStack, history])

  return backStack
}

export default useBrowserBackStack
